import React, {useState, useEffect} from "react";
import Ordergrocerymenubar from "./Ordergrocery/Ordergrocerymenubar";
import Ordergrocerymenucontents from "./Ordergrocery/Ordergrocerymenucontents";
import Grocerymenu from "./Ordergrocerymenujson";
import { useGetProductsQuery } from "../src/store/api/productApi";


const allcatvalues = ['All', ...new Set(Grocerymenu.map((curElem) => curElem.category ))];
const Ordergrocerymainmenu = () => {

    const [items, setItems] = useState(Grocerymenu);
    const [catItems, setCatItems] = useState(allcatvalues);
    const { data: products } = useGetProductsQuery();


    useEffect(() => {
        setCatItems(['All', ...new Set(products.map((curElem) => curElem.category ))])
    }, [products])
    

    const filterMenu = (category) => {
        if(category === "All"){
            setItems(Grocerymenu);
            return;
        }
        const updatedItems = Grocerymenu.filter((curElem) => {
            return curElem.category == category;
        });
        setItems(updatedItems);
    }

    return(
        <section className="main-menu-wrap ">
            {/* <nav class="nav">
                <a class="nav-link active" aria-current="page" href="#">All</a>
                <a class="nav-link" href="#">Dairy</a>
                <a class="nav-link" href="#">Fruits</a>
                <a class="nav-link" href="#">Meats</a>
                <a class="nav-link" href="#">Vegitables</a>
                <a class="nav-link" href="#">Grocery</a>
            </nav> */}

            {/* <!-- Nav tabs --> */}
                
            <Ordergrocerymenubar filterMenu = { filterMenu } catItems = {catItems}/>
            <Ordergrocerymenucontents items = { items }/>
             
        </section>
    )
}

export default Ordergrocerymainmenu;
